
            export function injectStyle(text) {
              if (typeof document !== 'undefined') {
                const style = document.createElement('style')
                style.id = 'superviz-style'
                const node = document.createTextNode(text)
                style.appendChild(node)
                document.head.appendChild(style)
              }
            }
          